const SHARE_HASH = /^#\/share\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

/** UUID ссылки из адреса вида #/share/<UUID>; другой адрес — null */
export function readShareLinkUuid(hash: string): string | null {
  const match = SHARE_HASH.exec(hash.trim())

  return match ? match[1].toLowerCase() : null
}

export function makeShareLinkUrl(origin: string, uuid: string): string {
  return origin + '/#/share/' + uuid
}
